import { render } from "./region.vue?vue&type=template&id=585c6b34"
import script from "./region.vue?vue&type=script&lang=js"
export * from "./region.vue?vue&type=script&lang=js"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__